/**
 * @generated SignedSource<<f7ed666f1df165c6e61bc504f075a465>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RedemptionOptions_redemptionOptionsRef$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly amountDenominations: ReadonlyArray<{
        readonly panelistCost: {
          readonly subUnitAmount: number;
        };
      }> | null;
      readonly id: string;
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"useRedemptionOptionItemQuery_optionRef">;
    };
  }>;
  readonly " $fragmentType": "RedemptionOptions_redemptionOptionsRef";
};
export type RedemptionOptions_redemptionOptionsRef$key = {
  readonly " $data"?: RedemptionOptions_redemptionOptionsRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"RedemptionOptions_redemptionOptionsRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RedemptionOptions_redemptionOptionsRef",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RedemptionOptionEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RedemptionOptionData",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AmountDenomination",
              "kind": "LinkedField",
              "name": "amountDenominations",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CurrencyAmount",
                  "kind": "LinkedField",
                  "name": "panelistCost",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "subUnitAmount",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "useRedemptionOptionItemQuery_optionRef"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RedemptionOptionConnection",
  "abstractKey": null
};

(node as any).hash = "e2beb83eab5a550e8a74684ff3188a80";

export default node;
